import clsx from 'clsx'

type ChipProps = {
  children: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

export const Chip = ({ children, ...props }: ChipProps) => {
  return (
    <div
      {...props}
      className={clsx(
        'flex flex-row items-center space-x-1 rounded-xl border border-gray-200 px-1.5 py-0.5',
        props.className
      )}>
      {children}
    </div>
  )
}
